import { LoadingAnimationStyleInterface } from "./loading_animation_interface";

export const loadingAnimationDefaultStyle: LoadingAnimationStyleInterface = {
    strokeWidth: "3",
    strokeLength: "8",
    radius: "13",
    animationColor: "primary",
};
